function applyQuantityLimit() {
  // Specific product IDs jo limit karne hai
  const limitedProductIds = ['10037920694588', '10037921055036'];
  
  const allQtyInputs = document.querySelectorAll('input[name="quantity"], input[name="updates[]"]');
  
  allQtyInputs.forEach((qtyInput) => {
    // Product ID find karne ke different methods
    let productId = null;
    
    // Method 1: Check if input has data-product-id attribute
    productId = qtyInput.getAttribute('data-product-id');
    
    // Method 2: Check parent elements for product ID
    if (!productId) {
      let parent = qtyInput.closest('[data-product-id]');
      if (parent) {
        productId = parent.getAttribute('data-product-id');
      }
    }
    
    // Method 3: Check for product ID in form action or hidden inputs
    if (!productId) {
      const form = qtyInput.closest('form');
      if (form) {
        // Check form action for product ID
        const actionUrl = form.getAttribute('action');
        if (actionUrl) {
          limitedProductIds.forEach(id => {
            if (actionUrl.includes(id)) {
              productId = id;
            }
          });
        }
        
        // Check hidden inputs for product ID
        if (!productId) {
          const hiddenInputs = form.querySelectorAll('input[type="hidden"]');
          hiddenInputs.forEach(input => {
            if (input.value && limitedProductIds.includes(input.value)) {
              productId = input.value;
            }
          });
        }
      }
    }
    
    // Method 4: Check URL parameters
    if (!productId) {
      const urlParams = new URLSearchParams(window.location.search);
      const productFromUrl = urlParams.get('variant') || urlParams.get('product');
      if (productFromUrl && limitedProductIds.includes(productFromUrl)) {
        productId = productFromUrl;
      }
    }
    
    // Method 5: Check for product ID in nearby elements
    if (!productId) {
      const productContainer = qtyInput.closest('.product-item, .product-card, .cart-item, [class*="product"]');
      if (productContainer) {
        // Check all elements within container for product ID
        const allElements = productContainer.querySelectorAll('*');
        allElements.forEach(element => {
          limitedProductIds.forEach(id => {
            if (element.textContent && element.textContent.includes(id)) {
              productId = id;
            }
            if (element.getAttribute('href') && element.getAttribute('href').includes(id)) {
              productId = id;
            }
          });
        });
      }
    }
    
    // Agar ye limited product hai toh limit apply karo
    if (productId && limitedProductIds.includes(productId)) {
      qtyInput.setAttribute('max', '1');
      
      // Remove existing event listener to avoid duplicates
      qtyInput.removeEventListener('change', quantityChangeHandler);
      
      // Add new event listener
      qtyInput.addEventListener('change', quantityChangeHandler);
    }
  });
}

function quantityChangeHandler() {
  if (parseInt(this.value) > 3) {
    alert('You can only purchase a maximum of 3 items of this product.');
    this.value = 1;
  }
}

// MutationObserver to handle dynamically added elements
const observer = new MutationObserver(() => {
  if (document.querySelectorAll('input[name="quantity"], input[name="updates[]"]').length > 0) {
    applyQuantityLimit();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// Apply on page load
document.addEventListener('DOMContentLoaded', applyQuantityLimit);

// Apply after a short delay to ensure all elements are loaded
setTimeout(applyQuantityLimit, 1000);